import {IRecordHistoryMyExperience} from './record-history-my-experience.interface';
import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext} from '@ngxs/store';
import {firstValueFrom} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BaseService, DataBaseServiceResponse} from '../../services/base-service/base.service';

export interface IRRecordHistoryMyExperience {
  recordHistoryMyExperience: IRecordHistoryMyExperience;
  recordHistoryMyExperiences: IRecordHistoryMyExperience[];
  wasDeployed?: boolean;
}

export namespace RecordHistoryExperienceAction {
  export class GetActive {
    static readonly type = '[Record] Get Record History MyExperience Action';
    constructor(public serviceId: string, public patientId: string) { }
  }

  export class GetByAppointment {
    static readonly type = '[Record] Get Record History MyExperiences By Appointment Action';
    constructor(public serviceId: string, public patientId: string, public appointmentId: string) { }
  }

  export class PatchActive {
    static readonly type = '[Record] Patch Record History MyExperience  Action';
    constructor(public serviceId: string, public patientId: string, public experienceId: string, public environmentAffectivity: IRecordHistoryMyExperience) { }
  }

  export class Deploy {
    static readonly type = '[Record] Was Deployed History MyExperience Action';
    constructor(public value: boolean) { }
  }
}


@State<IRRecordHistoryMyExperience>({
  name: 'RecordHistoryMyExperienceState',
  defaults: {
    recordHistoryMyExperience: null,
    recordHistoryMyExperiences: []
  },
})

@Injectable()
export class RecordHistoryMyExperienceState {
  constructor(
    private baseService: BaseService<any>,
  ) {
  }
  url = environment.SERVER_URL;

  @Selector()
  public static getRecordHistoryMyExperience(state: IRRecordHistoryMyExperience): IRecordHistoryMyExperience {
    return state.recordHistoryMyExperience;
  }

  @Selector()
  public static getWasDeployed(state: IRRecordHistoryMyExperience): boolean {
    return state.wasDeployed;
  }

  @Action(RecordHistoryExperienceAction.GetActive)
  async getRecordHistoryMyExperienceAction(
    ctx: StateContext<IRRecordHistoryMyExperience>,
    action: RecordHistoryExperienceAction.GetActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<IRecordHistoryMyExperience> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${action.patientId}/service/${action.serviceId}/records/experiences/active`)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({
      recordHistoryMyExperience: response.entity
    });
  }

  @Action(RecordHistoryExperienceAction.GetByAppointment)
  async getRecordHistoryMyExperienceByAppointmentAction(
    ctx: StateContext<IRRecordHistoryMyExperience>,
    {appointmentId, serviceId, patientId}: RecordHistoryExperienceAction.GetByAppointment
  ): Promise<void> {
    const response: DataBaseServiceResponse<IRecordHistoryMyExperience> = await firstValueFrom(
      this.baseService.get(`${this.url}/patients/${patientId}/service/${serviceId}/records/experiences/appointments/${appointmentId}`)
    );

    if (response.error) throw new Error(response.message);

    ctx.patchState({
      recordHistoryMyExperience: response.entity
    });
  }

  @Action(RecordHistoryExperienceAction.PatchActive)
  async patchRecordHistoryMyExperienceAction(
    ctx: StateContext<IRRecordHistoryMyExperience>,
    {environmentAffectivity, experienceId, patientId, serviceId}: RecordHistoryExperienceAction.PatchActive
  ): Promise<void> {
    const response: DataBaseServiceResponse<void> = await firstValueFrom(
      this.baseService.patch(`${this.url}/patients/${patientId}/service/${serviceId}/records/experiences/${experienceId}`, environmentAffectivity)
    );

    if (response.error) throw new Error(response.message);
  }

  @Action(RecordHistoryExperienceAction.Deploy)
  async wasDeployedRecordHistoryMyExperienceAction(
    ctx: StateContext<IRRecordHistoryMyExperience>,
    action: RecordHistoryExperienceAction.Deploy
  ): Promise<void> {
    ctx.patchState({
      wasDeployed: action.value
    });
  }
}
